import { createContext, useContext } from "react";

export const CampaignContext = createContext(null);

export const useCampaignContext = () => {
  return useContext(CampaignContext);
};
